import { Button, Checkbox, Col, Form, Input, Modal, Row, Select, Switch, Tooltip, message } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

const { TextArea } = Input;

const EditPlanModal = ({
  currentPlan,
  isEditVisible,
  onEditCancel,
  courseId,
  courseData,
  courseLoading,
  batchesToShow,
  batchLoading,
  planTypes,
  features,
  featuresEditState,
  setEditFeaturesState,
  handleEditFormSubmit,
  setCurrentPlan,
}) => {
  const [form] = Form.useForm();
  const [planName, setPlanName] = useState('');

  useEffect(() => {
    if (currentPlan) {
      form.setFieldsValue({
        name: currentPlan?.name,
        courseName: currentPlan && currentPlan?.course ? currentPlan.course.courseName : [],
        batch: currentPlan && currentPlan?.batch ? currentPlan?.batch?.name : [],
        free_price: currentPlan && currentPlan.features[0].type_price,
        silver_price: currentPlan && currentPlan.features[1].type_price,
        gold_price: currentPlan && currentPlan.features[2].type_price,
        platinum_price: currentPlan && currentPlan.features[3].type_price,
        options: currentPlan?.discount_codes || [],
      });
    }
  }, [currentPlan, form]);

  const handleCheckboxChange = (item, featureName, checked) => {
    setEditFeaturesState((prevState) => ({
      ...prevState,
      [`${item.toLowerCase()}_${featureName}`]: checked,
    }));
  };

  const displaySwitchChange = (item, checked) => {
    setEditFeaturesState((prevState) => ({
      ...prevState,
      [`${item.toLowerCase()}_toDisplay`]: checked,
    }));
  };

  const updateDisplaySwitch = (item, checked) => {
    setEditFeaturesState((prevState) => ({
      ...prevState,
      [`${item.toLowerCase()}_toDisplay`]: checked,
    }));
  };

  const handlePriceChange = (item, value) => {
    setEditFeaturesState((prevState) => ({
      ...prevState,
      [`${item.toLowerCase()}_price`]: value,
    }));
  };

  const closeEditModal = () => {
    setCurrentPlan(null);
    form.resetFields();
    onEditCancel();
  };

  // useEffect(() => {
  //   console.log(currentPlan, '------------------currentPlan');
  // }, [currentPlan]);

  return (
    <div>
      <Modal
        open={isEditVisible}
        style={{ top: 20 }}
        width={1000}
        title={currentPlan?.name}
        okText="Submit"
        cancelText="Cancel"
        onCancel={closeEditModal}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              handleEditFormSubmit(values);
            })
            .catch((info) => {
              console.log('Validate Failed:', info);
            });
        }}
      >
        <Form form={form} layout="horizontal">
          {/* Enter Name */}
          <Form.Item
            name="name"
            rules={[
              {
                required: true,
                message: 'Please enter name of the plan',
              },
            ]}
          >
            <Input
              value={planName}
              onChange={(e) => setPlanName(e.target.value)}
              placeholder="Enter the name of plan"
            />
          </Form.Item>

          {/* Select Course */}
          <Form.Item size={'large'} name="courseName" rules={[{ required: true, message: 'Please select a course!' }]}>
            <Select placeholder="Select course" disabled>
              {courseLoading && courseData.length === 0 ? (
                <Select.Option value={null}>Loading courses .....</Select.Option>
              ) : courseData.length === 0 ? (
                <Select.Option value={null}>No courses assigned.</Select.Option>
              ) : (
                courseData.map((course) => (
                  <Select.Option key={course.courseName} value={course._id}>
                    {course.courseName}
                  </Select.Option>
                ))
              )}
            </Select>
          </Form.Item>

          {/* Select Batches */}
          <Form.Item name="batch" rules={[{ required: true, message: 'Please select a batch!' }]}>
            <Select placeholder="Select batches" disabled>
              {batchLoading && batchesToShow.length === 0 ? (
                <Select.Option disabled value={null}>
                  Loading batches .....
                </Select.Option>
              ) : courseId === null && batchesToShow.length === 0 ? (
                <Select.Option disabled value={null}>
                  No course selected.
                </Select.Option>
              ) : batchesToShow.length === 0 ? (
                <Select.Option disabled value={null}>
                  All batches are already having a plan.
                </Select.Option>
              ) : (
                batchesToShow.map((batch) => (
                  <Select.Option key={batch._id} value={batch._id}>
                    {batch.name}
                  </Select.Option>
                ))
              )}
            </Select>
          </Form.Item>

          {/* Select Features */}
          <Row gutter={8}>
            {planTypes.map((item, index) => (
              <Col span={12} key={index}>
                <div span={16} className="border my-2">
                  <div className="flex items-center justify-between w-full flex-wrap px-3 border-b text-lg font-semibold">
                    <div>
                      {item} <span className="text-xs font-normal">(Select features to enable)</span>{' '}
                    </div>
                    <Form.Item name={`${item.toLocaleLowerCase()}_toDisplay`} className="mb-0">
                      <Tooltip title={`Enable to display this plan`}>
                        <Switch
                          onChange={(checked) => displaySwitchChange(item, checked)}
                          checked={featuresEditState[`${item.toLowerCase()}_toDisplay`]}
                        />
                      </Tooltip>
                    </Form.Item>
                  </div>
                  {features.map((feature, i) => (
                    <div key={i}>
                      <Form.Item name={`${item.toLowerCase()}_${feature.name}`} className="p-0 m-0">
                        <div className="flex items-center justify-between mx-3 flex-wrap">
                          <p className="mb-0">{feature.name}</p>
                          <input
                            type="checkbox"
                            className="w-4 h-4 shadow-xl"
                            onChange={(e) => handleCheckboxChange(item, feature.name, e.target.checked)}
                            checked={featuresEditState[`${item.toLowerCase()}_${feature.name}`]}
                          />
                        </div>
                      </Form.Item>
                    </div>
                  ))}
                </div>
                {/* Enter Price */}
                <Form.Item
                  label={<p className="mb-0 text-sm">Enter price for {item.toLowerCase()} plan</p>}
                  name={`${item.toLowerCase()}_price`}
                  rules={[
                    {
                      required:
                        featuresEditState[`${item.toLowerCase()}_toDisplay`] && item.toLocaleLowerCase() !== 'free'
                          ? true
                          : false,
                      message: `Please enter price of ${item.toLowerCase()} plan`,
                    },
                  ]}
                >
                  <Input
                    disabled={item.toLowerCase() === 'free' ? true : false}
                    onChange={(e) => handlePriceChange(item, e.target.value)}
                    placeholder={`Enter the price of ${item.toLowerCase()} plan`}
                    size={'middle'}
                  />
                </Form.Item>
              </Col>
            ))}
          </Row>

          {/* Discount coupons */}
          <Form.List name="options">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }, index) => (
                  <Row key={index} gutter={8} className="flex items-center justify-start flex-wrap">
                    <Col span={11}>
                      <Form.Item
                        {...restField}
                        name={[name, 'discount_coupon']}
                        rules={[{ required: true, message: 'Please enter coupon code' }]}
                      >
                        <Input placeholder="Discount Coupon" />
                      </Form.Item>
                    </Col>
                    <Col span={11}>
                      <Form.Item
                        {...restField}
                        name={[name, 'percentage_discount']}
                        rules={[{ required: true, message: 'Please enter percentage discount value' }]}
                      >
                        <Input type="number" placeholder="Percentage discount" />
                      </Form.Item>
                    </Col>
                    <Col span={2}>
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Col>
                  </Row>
                ))}
                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                    disabled={fields.length === 5}
                  >
                    Add Discount Coupons
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        </Form>
      </Modal>
    </div>
  );
};

export default EditPlanModal;
